/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Numbers_RequiredInputs */

const en_cna_numbers_required = /** @type {(inputs: Cna_Numbers_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter at least one phone number you called.`)
};

const ja_cna_numbers_required = /** @type {(inputs: Cna_Numbers_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`発信した電話番号を少なくとも1件入力してください。`)
};

const fr_cna_numbers_required = /** @type {(inputs: Cna_Numbers_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indiquez au moins un numéro de téléphone appelé.`)
};

const de_cna_numbers_required = /** @type {(inputs: Cna_Numbers_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie mindestens eine angerufene Telefonnummer an.`)
};

/**
* | output |
* | --- |
* | "Enter at least one phone number you called." |
*
* @param {Cna_Numbers_RequiredInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_numbers_required = /** @type {((inputs?: Cna_Numbers_RequiredInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Numbers_RequiredInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_numbers_required(inputs)
	if (locale === "ja") return ja_cna_numbers_required(inputs)
	if (locale === "fr") return fr_cna_numbers_required(inputs)
	return de_cna_numbers_required(inputs)
});